import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useBotId } from '../../../../store/flow'
import { Button } from '../../../design-system/Button'
import { endpointHelpers } from '../../../../features/serverBots/endpointHelpers'
import { initiateBotDelete } from '../../../../features/serverBots/actions/botDeactivation/initiateBotDelete/initiateBotDelete'

export const DeleteBotButton: React.FC = () => {
  const botId = useBotId()
  const dispatch = useDispatch()
  const { isLoading } = useSelector(endpointHelpers.deleteBot.fixedKeySelector({ botId }))

  return (
    <Button
      size="medium"
      role="negative"
      emphasis="primary"
      label="Delete bot"
      loading={isLoading}
      disabled={isLoading}
      minMaxSizes={{ minWidth: 100, maxHeight: 36 }}
      onClick={async event => {
        event.preventDefault()
        dispatch(initiateBotDelete(botId))
      }}
    />
  )
}
